import { Select } from 'antd';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { showRelateToEntityText } from '@/shared/helpers/relate-to-name.helper';
import { JSX, useEffect, useState } from 'react';
import { NewContactForm } from '@/components/Forms/NewContact';
import { NewAccountForm } from '@/components/Forms/NewAccount';
import { NewLeadForm } from '@/components/Forms/NewLead';
import { NewOpportunityForm } from '@/components/Forms/NewOpportunity';
import { NewCaseForm } from '@/components/Forms/NewCase';
const { Option } = Select;
import './CallPanel.scss';

const optionsRender = (): JSX.Element[] => {
  const opts = [
    EEntity.ACCOUNT,
    EEntity.CONTACT,
    EEntity.LEAD,
    EEntity.OPPORTUNITY,
    EEntity.CASE,
  ];
  return opts.map((e, i) => {
    return (
      <Option key={i} value={e}>
        {showRelateToEntityText(e)}
      </Option>
    );
  });
};

interface IProps {
  setUnsavedFormData: (flag: boolean) => void;
  data: any;
  client: any;
}

const formRenderer = (
  variant: string,
  setUnsavedFormData: (flag: boolean) => void,
  data: any,
  prefilledPhone,
) => {
  switch (variant) {
    case 'account':
      return (
        <NewAccountForm
          setUnsavedFormData={setUnsavedFormData}
          data={data}
          prefilledPhone={prefilledPhone}
        />
      );
    case 'contact':
      return (
        <NewContactForm
          setUnsavedFormData={setUnsavedFormData}
          data={data}
          prefilledPhone={prefilledPhone}
        />
      );
    case 'lead':
      return (
        <NewLeadForm
          setUnsavedFormData={setUnsavedFormData}
          data={data}
          prefilledPhone={prefilledPhone}
        />
      );
    case 'opportunity':
      return (
        <NewOpportunityForm
          setUnsavedFormData={setUnsavedFormData}
          data={data}
        />
      );
    case 'incident':
      return (
        <NewCaseForm
          setUnsavedFormData={setUnsavedFormData}
          data={data}
          prefilledPhone={prefilledPhone}
        />
      );

    default:
      return <></>;
  }
};

export const CreateBlock = ({ setUnsavedFormData, data, client }: IProps) => {
  const [createOpt, setCreateOpt] = useState<EEntity | null>(null);

  const prefilledPhone: string =
    client?.fullName !== 'Unknown' ? '' : client.initialPhone;

  useEffect(() => {
    if (data) {
      setCreateOpt(Object.keys(data)[0].toLocaleLowerCase() as EEntity);
    }
  }, []);

  const onChangeOpt = async (value: EEntity) => {
    setCreateOpt(value);
  };

  return (
    <div className="note__relate-to">
      <div className="main-text note__header">Create</div>
      <Select
        className="note__select-entity"
        data-testid="select-create-entity"
        showSearch
        placeholder="Select an entity"
        optionFilterProp="children"
        onChange={onChangeOpt}
        filterOption={(input, option) =>
          (option?.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        value={createOpt}
      >
        {optionsRender()}
      </Select>
      {formRenderer(createOpt, setUnsavedFormData, data, prefilledPhone)}
    </div>
  );
};
